import React, { Component, PropTypes } from 'react'
import {UnControlled as CodeMirror} from 'react-codemirror2'
import { connect } from 'react-redux'
import './style.scss'
import {emptyArrCleaner, objCleaner} from '../../helpers'
import {base} from '../../../config'
import Link from 'react-router'
import StripePayments from '../../components/StripePayments'
import CardPayment from '../../components/CardPayment'


const schema = {
  type: "object",
  required: ["label"],
  properties: {
    "user_details": {
      "type": "object",
       "title": "My Details",
      "properties": {
        name: { "type": "string", "title": "My Name" },
        number: { "type": "string", "title": "My Phone Number" }
      },
      "required": []
    },
    "invoice_settings": {
      "type": "object",
       "title": "Quote / Invoice Settings",
      "properties": {
        business_name: { "type": "string", "title": "My Business Name" },
        "street_address": {
          "type": "string"
        },
        "city": {
          "type": "string"
        },
        "county": {
          "type": "string"
        },
        "postcode": {
          "type": "string"
        },
        number: { "type": "string", "title": "Phone Number" }
      },
      "required": [
        "street_address",
        "city",
        "state"
      ]
    }
  }
}

const schemaUi = {
  label: {  "ui:placeholder": "Name", "ui:options": { "label": true } }
}

import Form from "react-jsonschema-form"

import { newJob } from '../../../config'

function parseData (content) {
  try {
    return JSON.parse(content)
  } catch (e) {
    return false
  }
}

function stringifyData (content) {
  try {
    return JSON.stringify(content, null, 2)
  } catch (ex) {
    return null
  }
}

export class Settings extends Component {

    constructor(props) {
        super(props);
        this.state = {
          tab: 0,
          data: {},
          dataNew: null,
          formData: {},
          section: 'details'
        }
        this._onChange = this._onChange.bind(this)
        this._notiSave = _.debounce(this._notiSave, 1000)
    }

    _notiSave () {
      this.props.notify('Job Saved', 1, 'success')
    }

    componentDidMount () {
      const _this = this
      base.fetch(`user_details/${this.props.uid}/default`, {
        context: this,
        then(data){
          if (_.isEmpty(data)) {
            _this.setState((state) => ({
              data: newJob
            }))
          } else {
            _this.setState((state) => ({
              data: data
            }))
          }
          base.syncState(`user_details/${this.props.uid}/details`, {
             context: this,
             state: 'formData',
             then(data){}
           })
        }
      })
    }

    _checkSave () {
      base.post(`user_details/${this.props.uid}/default`, {
        data: this.state.dataNew
      })
    }

    _delete () {
      base.remove(`user_details/${this.props.uid}/default`, (err) => {
        if(!err) {
          window.location = window.location
        }
      })
    }

    _onChange (editor, data, value) {
      console.log(value)
      this.setState({
        dataNew: parseData(value)
      })


      console.log(this.state.dataNew)
    }

    _change (event) {
      this.setState({
        formData: event.formData
      })
      this._notiSave()
    }

    changeSection (section) {
      this.setState({section})
    }

    render() {

        return (
          <div className='settings with-sidebar main-pt full-width-page'>


            <div className='row'>

              <div className='col-sm-3'>




                <div className='panel'>



                  <div className='panel-heading'>
                    Settings
                  </div>
                  <div className="panel-footer">
                    <div className="job-views">
                      <a className='' onClick={this.changeSection.bind(this, 'details')}>
                        <div>
                          <i className='icon-lock' />
                        </div>
                        <p>My Details<br/><small>hgkjhjg</small></p>
                        <i className="icon-chevron-right pull-right"></i>
                      </a>
                      <a className='' onClick={this.changeSection.bind(this, 'settings')}>
                        <div>
                          <i className='icon-lock' />
                        </div>
                        <p>Job Settings<br/><small>hgkjhjg</small></p>
                        <i className="icon-chevron-right pull-right"></i>
                      </a>
                      <a className='' onClick={this.changeSection.bind(this, 'pay')}>
                        <div>
                          <i className='icon-lock' />
                        </div>
                        <p>Payment / Signup<br/><small>hgkjhjg</small></p>
                        <i className="icon-chevron-right pull-right"></i>
                      </a>
                    </div>

                  </div>
                </div>
              </div>


              <div className='col-sm-9'>

                {this.state.section === 'details' &&
                  <div>
                    <div className='panel'>
                      <div className='panel-heading'>
                        Settings
                      </div>
                      <div className='panel-body hide-submit'>
                        <Form
                          formData={this.state.formData}
                          schema={schema}
                          uiSchema={schemaUi}
                          onChange={this._change.bind(this)}
                        />
                      </div>
                    </div>

                  </div>
                }

                {this.state.section === 'settings' &&
                  <div>
                    <h4 className='m-t-0 m-b-lg'>Job Settings</h4>


                      <div className='row'>

                          <div className='col-sm-9'>
                          <div className="filters">
                            <CodeMirror
                              ref="code"
                              value={stringifyData(this.state.data)}
                              onChange={(editor, data, value) => this._onChange(editor, data, value)}
                              options={{
                                mode: 'javascript',
                                lineNumbers: true
                              }}
                            />
                          </div>
                        </div>
                        <div className='col-sm-3'>
                        <div className="filters">
                          <button className='btn btn- btn-block btn-success m-b-md' onClick={this._checkSave.bind(this)}>
                            Save
                          </button>
                          <button className='btn btn- btn-block btn-danger m-b-' onClick={this._delete.bind(this)}>
                            Delete Default
                          </button>
                          </div>
                        </div>
                      </div>

                    </div>
                }

                {this.state.section === 'pay' &&
                  <div className='panel'>
                    <div className='panel-body'>
                      <CardPayment />
                    </div>
                  </div>

                }


              </div>

            </div>
          </div>
        )
    }
}

export default Settings



// WEBPACK FOOTER //
// ./src/views/pages/Settings/index.js